<template>
  <DsShowcase title="BreadcrumbPlay" description="Navegação hierárquica com botão de voltar e separadores. Usado em páginas de edição e formulários aninhados.">
    <!-- PROP: items -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">items</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>BreadcrumbItem[]</code> — array de itens com <code>name</code> e <code>path</code> opcional. O último item é exibido como ativo (bold).</p>
      <div class="tw:max-w-lg tw:space-y-6">
        <BreadcrumbPlay
          :items="[
            { name: 'Cursos', path: '/cursos' },
            { name: 'Turmas', path: '/cursos/turmas' },
            { name: 'Nova turma' },
          ]"
          @back="() => {}"
        />

        <BreadcrumbPlay
          :items="[
            { name: 'Configurações', path: '/configuracoes' },
            { name: 'Aparência' },
          ]"
          @back="() => {}"
        />

        <BreadcrumbPlay
          :items="[
            { name: 'Home', path: '/' },
            { name: 'Cronograma de estudos', path: '/cronograma' },
            { name: 'Semana 1', path: '/cronograma/semana-1' },
            { name: 'Detalhes' },
          ]"
          @back="() => {}"
        />
      </div>
    </section>

    <!-- PROP: showBack -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">showBack</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — controla a exibição do botão de voltar. Padrão: <code>true</code></p>
      <div class="tw:max-w-lg tw:space-y-6">
        <div>
          <p class="tw:text-xs tw:opacity-50 tw:mb-2">Com botão de voltar (padrão)</p>
          <BreadcrumbPlay
            :items="[{ name: 'Cursos', path: '/cursos' }, { name: 'Editar curso' }]"
            @back="() => {}"
          />
        </div>
        <div>
          <p class="tw:text-xs tw:opacity-50 tw:mb-2">Sem botão de voltar</p>
          <BreadcrumbPlay
            :show-back="false"
            :items="[{ name: 'Cursos', path: '/cursos' }, { name: 'Editar curso' }]"
          />
        </div>
      </div>
    </section>

    <!-- Single item -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Item único</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Quando há apenas um item, funciona como título de página com botão de voltar.</p>
      <div class="tw:max-w-lg">
        <BreadcrumbPlay
          :items="[{ name: 'Detalhes da turma' }]"
          @back="() => {}"
        />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
import { BreadcrumbPlay } from '@/components/atomic'
</script>
